import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

interface UserIdFilterProps {
  filterIndex: number;
}

/**
 * Renders a text input for filtering sessions by user ID
 */
export const UserIdFilter = ({ filterIndex }: UserIdFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const userId = useWatch({ control, name: `filters.${filterIndex}.userId` }) || '';

  const handleUserIdChange = (value: string) => {
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, userId: value });
  };

  return (
    <Input
      id={`user-id-${filterIndex}`}
      type="text"
      placeholder={t('analytics.filters.userIdPlaceholder')}
      value={userId}
      onChange={(e) => handleUserIdChange(e.target.value)}
      className="w-full"
    />
  );
};
